let elementName = `nss-buybox-gallery-variant`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSBuyboxGallery extends HTMLElement {
    constructor() {
      super();

      this.debug = false;

      this.els = {
        swiperMain: this.querySelector(`.js-nss-buybox-gallery-main`),
        swiperThumb: this.querySelector(`.nss-buybox__gallery-thumb`),
        swiperPrev: this.querySelector(`.nss-buybox__seeds-arrow--prev`),
        swiperNext: this.querySelector(`.nss-buybox__seeds-arrow--next`),
      };

      this.swiper = {
        main: null,
        thumb: null,
      };

      this.variantId = this.getAttribute(`nss-variant-id`);
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Buybox Gallery] Connected.`);

      this.initGallery();
      this.addEventListener(`buyboxUpdate`, this.handleUpdate.bind(this));
    }

    initGallery() {
      this.carouselEl = this.querySelector(`.js-nss-buybox-gallery-carousel`);
      if (this.carouselEl != null) {
        this.initCarousel();
        return;
      }
      // this.swiper.thumb = new Swiper(this.els.swiperThumb, {
      //   spaceBetween: 10,
      //   slidesPerView: 3,
      //   watchSlidesVisibility: true,
      //   watchSlidesProgress: true,
      //
      //   breakpoints: {
      //     370: {
      //       slidesPerView: 4,
      //       spaceBetween: 15,
      //     },
      //     525: {
      //       slidesPerView: 5,
      //     },
      //     990: {
      //       slidesPerView: 4,
      //     },
      //     1170: {
      //       slidesPerView: 5,
      //       spaceBetween: 20,
      //     },
      //   },
      // });
      //   thumbs: {
      //       swiper: this.swiper.thumb
      //   }
      if (this.els.swiperMain != null) {
        this.swiper.main = new Swiper(this.els.swiperMain, {
          spaceBetween: 0,
          slidesPerView: "auto",
          // Slides are <li>; Swiper's default role="group" breaks the list semantics.
          a11y: { enabled: true, slideRole: null },
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
          },
          navigation: {
            prevEl: this.els.swiperPrev,
            nextEl: this.els.swiperNext,
          },
          on: {
            slideChange: () => {
              this.pauseInternalVideos();
            },
          },
        });
      }
    }
    initCarousel() {
      this.carouselEl
        .querySelectorAll(`.nss-buybox__gallery-slide--props-only`)
        .forEach((slide) => slide.remove());

      const prev = this.querySelector(`.js-nss-buybox-gallery-prev`);
      const next = this.querySelector(`.js-nss-buybox-gallery-next`);

      this.swiper.main = new Swiper(this.carouselEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: { enabled: true, slideRole: null },
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        on: {
          slideChange: () => {
            this.pauseInternalVideos();
            this.syncThumbs();
          },
        },
      });

      this.thumbs = Array.from(this.querySelectorAll(`.nss-buybox__gallery-thumb`));
      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener(`click`, () => this.swiper.main.slideTo(i));
      });
      this.syncThumbs();
    }

    syncThumbs() {
      if (!this.thumbs || !this.swiper.main) return;
      const active = this.swiper.main.activeIndex;
      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle(`nss-active`, i === active);
      });
      const activeThumb = this.thumbs[active];
      if (activeThumb) {
        activeThumb.scrollIntoView({ block: `nearest`, inline: `center`, behavior: `smooth` });
      }
    }

    pauseInternalVideos() {
      const videoCards = this.querySelectorAll("nss-video-card");
      videoCards.forEach((card) => {
        if (typeof card.pause === "function") {
          card.pause();
        } else {
          const videos = card.querySelectorAll("video");
          videos.forEach((v) => v.pause());
        }
      });
    }
    handleUpdate(e) {
      const oldId = e.detail.oldId;
      const newId = e.detail.newId;
      const scope =
        this.closest(`nss-buybox`) || this.closest(`[id^="shopify-section"]`) || document;
      if (!scope.querySelector(`[nss-buybox-update][nss-variant-id="${newId}"]`)) {
        return;
      }
      if (newId === this.variantId) {
        this.classList.add(`nss-active`);
      } else {
        // setTimeout(() => {
        this.classList.remove(`nss-active`);
        // }, 125);
      }
    }
  }

  customElements.define(elementName, NSSBuyboxGallery);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
